import React from "react";
import { Box, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";

interface Props {
  order_date: string | null;
  completed_on: string | null;
  valid_until: string | null;
}

const EventParticipationInfoBoxTooltip: React.FC<Props> = ({
  order_date,
  completed_on,
  valid_until,
}) => {
  const { t } = useTranslation(["organization"]);

  return (
    <Box>
      <Typography variant="body1">
        {t("bookings.tooltips.bookedOn", {
          date: order_date || "-",
          ns: "organization",
        })}
      </Typography>
      <Typography variant="body1">
        {t("bookings.tooltips.completedOn", {
          date: completed_on || "-",
          ns: "organization",
        })}
      </Typography>
      <Typography variant="body1">
        {t("bookings.tooltips.validUntil", {
          date: valid_until || "-",
          ns: "organization",
        })}
      </Typography>
    </Box>
  );
};

export default EventParticipationInfoBoxTooltip;
